import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Container } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqs = [
  {
    question: "What products does Yealink offer?",
    answer: "Yealink offers IP phones, video conferencing systems, headsets, speakerphones, and related communication devices."
  },
  {
    question: "Are Yealink devices compatible with platforms like Zoom or Microsoft Teams?",
    answer: "Yes, many Yealink products are certified for Microsoft Teams, Zoom, and other major UC platforms."
  },
  {
    question: " Does Yealink support Wi-Fi and Bluetooth?",
    answer: "Yes, many Yealink models have built-in Wi-Fi and Bluetooth or support them through adapters."
  }
];

const FAQSection = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 5 , mb:5}}>
      <Typography variant="h4" gutterBottom>
        Frequently Asked Questions
      </Typography>
      {faqs.map((faq, index) => (
        <Accordion key={index}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1">{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
};

export default FAQSection;
